import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const DanceMusic = () => {
    useEffect(() => {
        document.title = 'Dance & Music -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                 <li>Co-Scholastic Dept</li>
                 <li>Dance & Music</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Dance & Music </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12">
                   <p>Children are taught folk, light, and classical music along with instruments such as sitar, harmonium, bongo, etc. Children are taught to appreciate music and dance. The fundamentals of various dance forms are also taught to students</p>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic.png" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-xl-3 col-lg-4 col-md-6">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic2.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic2.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
              <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic3.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/DanceMusic3.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
            </LazyLoad>  
             </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default DanceMusic